import { Component } from "@angular/core";

@Component({
    selector: "app-payment-modes",
    templateUrl: "./payment-modes.component.html",
    styleUrls: ["./payment-modes.component.scss"],
    standalone: false,
})
export class PaymentModesListComponent {}
